import React, { useEffect, useState } from 'react'
import { getAllSystemUsers } from '../../../../_utils/resourceAPI';
import { User } from '../../../../_models/User.model';
import { UpdateUser } from '../UpdateUsers/UpdateUsers';
import { useUserContext } from '../../../../_context/UserContext';
import { UserUpdatedSuccessModal } from '../UpdateUsers/UserUpdatedSuccessModal';

const SearchIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="11" cy="11" r="8" /><line x1="21" y1="21" x2="16.65" y2="16.65" />
  </svg>
);

export const AddedUsers = () => {
  const [allAddedSysUsers, setAllAddedSysUsers] = useState<User[]>([]);
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [activeTab, setActiveTab] = useState<"active" | "discontinued">("active");
  const { setUserUpdated } = useUserContext();

  const fetchSysUsers = () => {
    getAllSystemUsers()
      .then(res => setAllAddedSysUsers(res.data))
      .catch(err => console.error("Failed to fetch users:", err));
  };

  useEffect(() => { fetchSysUsers(); }, []);

  const activeUsers = allAddedSysUsers.filter(u => !u.discontinued);
  const discontinuedUsers = allAddedSysUsers.filter(u => u.discontinued === true);

  const filterUsers = (users: User[]) =>
    users.filter(u =>
      u.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      u.username.toLowerCase().includes(searchTerm.toLowerCase()) ||
      u.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
      u.role.toLowerCase().includes(searchTerm.toLowerCase())
    );

  const filteredActive = filterUsers(activeUsers);
  const filteredDiscontinued = filterUsers(discontinuedUsers);
  const displayUsers = activeTab === "active" ? filteredActive : filteredDiscontinued;

  const onUserUpdate = () => { fetchSysUsers(); setUserUpdated(true); };

  return (
    <div>
      {/* Search */}
      <div className="au-search-wrap">
        <span className="au-search-icon"><SearchIcon /></span>
        <input
          type="text"
          className="au-search-input"
          placeholder="Search by name, username, email or role…"
          value={searchTerm}
          onChange={e => setSearchTerm(e.target.value)}
        />
      </div>

      {/* Pill tabs */}
      <div className="au-tabs">
        <button
          className={`au-tab${activeTab === "active" ? " active" : ""}`}
          onClick={() => setActiveTab("active")}
        >
          Active Users ({filteredActive.length})
        </button>
        <button
          className={`au-tab${activeTab === "discontinued" ? " active" : ""}`}
          onClick={() => setActiveTab("discontinued")}
        >
          Discontinued ({filteredDiscontinued.length})
        </button>
      </div>

      {/* Table */}
      {displayUsers.length === 0 ? (
        <div className="au-empty">No users found</div>
      ) : (
        <div className="au-table-wrap">
          <table className="au-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Email</th>
                <th>Role</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {displayUsers.map(user => user ? (
                <tr key={user.id}>
                  <td data-label="Name"><span className="truncate-text">{user.name}</span></td>
                  <td data-label="Email" style={{ color: "#6B7280" }}><span className="truncate-text">{user.email}</span></td>
                  <td data-label="Role">
                    <span className={`au-role-pill${user.role === "admin" ? " admin" : ""}`}>
                      {user.role}
                    </span>
                  </td>
                  <td data-label="Status">
                    <span className={`au-badge ${user.discontinued ? "discontinued" : "active"}`}>
                      <span className="au-badge-dot" />
                      {user.discontinued ? "Discontinued" : "Active"}
                    </span>
                  </td>
                  <td data-label="Action">
                    <UpdateUser toUpdateUser={user} onUserUpdate={onUserUpdate} key={user.id} />
                  </td>
                </tr>
              ) : null)}
            </tbody>
          </table>
        </div>
      )}

      <UserUpdatedSuccessModal />
    </div>
  );
};
